var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDisableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 4,
    fill: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15V8H14V15H7V17H14V24H16V17H23V15H16Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDisableIcon);
export default __webpack_public_path__ + "static/media/AddDisableIcon.c1805f1952d9ea9d5f929ca9b35702da.svg";
export { ForwardRef as ReactComponent };